import { createMuiTheme } from 'material-ui/styles';
import { createMuiTheme as createMuiCoreTheme } from '@material-ui/core/styles';

export default createMuiTheme({
    palette: {
        primary: { main: '#000000' },
        secondary: { main: '#00BD75' }
    },
    typography: {
        fontFamily: ['Poppins', 'sans-serif'].join(','),
        body2: {
            fontSize: 14,
            fontWeight: 400
        },
        overline: {
            fontSize: 12,
            fontWeight: 700,
            textTransform: 'uppercase'
        }
    }
});

export const customTheme = createMuiCoreTheme({
    typography: {
        fontFamily: 'Poppins',
        h4: {
            fontSize: 24,
            fontStyle: 'italic',
            fontWeight: 700
        }
    },
    overrides: {
        MuiSwitch: {
            switchBase: {
                color: '#979797'
            },
            colorSecondary: {
                '&$checked': {
                    color: '#0A0EFF'
                }
            },
            track: {
                opacity: 0.2,
                backgroundColor: '#979797',
                '$checked$checked + &': {
                    opacity: 0.6,
                    backgroundColor: '#0A0EFF'
                }
            }
        }
    }
});



// WEBPACK FOOTER //
// ./src/view/TrainHeroicTheme.jsx